import React from "react";
import { BarChart3, Copy, Link2 } from "lucide-react";
import Layout from "../components/Layout";
import MhMFlow from "../components/tools/mhm/MhMFlow";
import { API, BACKEND_URL } from "../App";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

const MhMPage = () => {
  const campaignUrl = `${window.location.origin}/mhm/start`;

  const copyCampaignLink = () => {
    navigator.clipboard.writeText(campaignUrl);
    toast.success("Campaign link copied!");
  };

  return (
    <Layout>
      <div className="p-6 max-w-4xl mx-auto space-y-6" data-testid="mhm-page">
        <div className="flex items-center justify-between">
          <div className="text-center flex-1">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center mx-auto mb-3">
              <BarChart3 className="w-6 h-6 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900 font-['Manrope']">MyHomeMatrix</h1>
            <p className="text-sm text-slate-500 mt-1">AI-assisted home-buying prioritization and project matching</p>
          </div>
        </div>
        <div className="flex justify-center">
          <Button variant="outline" size="sm" onClick={copyCampaignLink} data-testid="copy-campaign-link">
            <Link2 className="w-4 h-4 mr-1.5" /> Copy Campaign Link
          </Button>
        </div>
        <MhMFlow apiBase={API} />
      </div>
    </Layout>
  );
};

export default MhMPage;
